<template>
  <div>
    <div class="face-container" @click="photograph">
      <div class="face-tip">
        <div class="tip" v-if="type==1">保持面部在框定范围内</div>
        <div class="tip" v-else>请将舌头靠近摄像头</div>
        <div class="tip col">点击屏幕拍摄</div>
      </div>
      <div class="face-camera">
        <img src="../../../images/face_bg.png" alt=" " class="face_bg"/>
        <div class="video">
          <canvas ref="canvas" style="display: none"></canvas>
          <canvas ref="previewCanvas" class="preview-canvas"></canvas>
          <video ref="video" autoplay playsinline webkit-playsinline muted
                 style="position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;overflow:hidden;"></video>
        </div>
      </div>
      <div class="face-con"/>
    </div>
    <div class="loading flex flex-x flex-y" v-if="loading">
        <div class="loading-box">
          <div class="loading-icon">
            <van-loading />
            <div class="loading-ui">上传中</div>
          </div>
        </div>
      </div>
      <div class="loading black flex flex-x flex-y" v-if="no_show">
          <div class="loading-box">
              <div class="load-bac">
                <img src="../../../images/false.png" alt=" " class="icon-img"/>
                <div class="load-no">{{no_show}}</div>
                <img src="../../../images/face1.png" alt=" " class="load-img" v-if="type==1"/>
                <img src="../../../images/tongues.png" alt=" " class="load-img" v-else/>
                <div class="again" @click="photoFun">重新检测</div>
              </div>
          </div>
      </div>
      <div class="loading black flex flex-x flex-y" v-if="explain">
          <div class="loading-box">
              <div class="load-bac">
                <img src="../../../images/status-ok.png" alt=" " class="icon-img"/>
                <div class="load-explain">{{explain}}</div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
  import "./camera.scss";
  import { mapActions , mapMutations , mapState } from "vuex";
  export default {
    name: "camera",
    data () {
      return {
        imgSrc: "",
        stream: null
      };
    },
    props: ["type"],
    created: function () {
      if (sessionStorage && (sessionStorage.device === "android" && !sessionStorage.camera)) {
        this.startUpAndroidCamera ();
      }
    },
    mounted: function () {
      if (!(sessionStorage && (sessionStorage.device === "android" && !sessionStorage.camera))) {
        this.startUpWebCamera ();
      }
    },
    computed:{
      ...mapState('step',['show','loading','no_show','explain']),
    },
    beforeDestroy(){
      if (this._rafId) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
    },
    methods: {
      // 启动H5摄像头
      startUpWebCamera () {
        if (navigator.mediaDevices) {
          navigator.mediaDevices.getUserMedia ({ audio: false, video: true }).then (stream => {
            this.stream = stream;
            const video = this.$refs["video"];
            if (!video) return;

            video.srcObject = stream;

            video.onloadeddata = () => {
              video.play().then(() => {
                const preview = this.$refs["previewCanvas"];
                if (preview && video.videoWidth) {
                  preview.width = video.videoWidth;
                  preview.height = video.videoHeight;
                }
                this.renderLoop();
              }).catch(() => {});
            };
          }).catch(() => {});
        }
      },
      renderLoop () {
        const video = this.$refs["video"];
        const preview = this.$refs["previewCanvas"];
        if (!video || !preview || !this.stream) return;
        if (video.readyState >= video.HAVE_CURRENT_DATA) {
          const ctx = preview.getContext("2d");
          ctx.drawImage(video, 0, 0, preview.width, preview.height);
        }
        this._rafId = requestAnimationFrame(() => this.renderLoop());
      },
      // 启动安卓（设备端）摄像头
      startUpAndroidCamera () {
        window["ReactNativeWebView"].postMessage ("photo");
        window.obj = {};
        var _this = this;
        Object.defineProperty(window.obj, "url", {
          get: function () {
            return '';
          },
          set: function (newValue) {
            _this.axiosData({
              data:{
                photo:newValue,
                type:_this.$props.type
              },
              _this:_this
            })
          },
        });
      },

      photoFun(){
        this.againFun();
        if (sessionStorage && (sessionStorage.device === "android" && !sessionStorage.camera)) {
          this.startUpAndroidCamera ();
        }
      },

      // 拍照
      photograph () {
        let video = this.$refs["video"];
        let canvas = this.$refs["canvas"];
        let ctx = canvas.getContext("2d");
        canvas.width = 1200;
        canvas.height = video.videoHeight * (canvas.width / video.videoWidth);
        ctx.drawImage(
            video,
            0,
            0,
            canvas.width,
            canvas.height
        );
        const image = canvas.toDataURL('image/jpeg');
        this.axiosData({
          data:{
            photo:image,
            type:this.$props.type
          },
          _this:this
        })
      },
      ...mapMutations ("step", ["againFun"]),
      ...mapActions ("step", ["axiosData"])
    }
  };
</script>
